<template>
  <div>
    <PageHeader :schema="$schemas.openTitle" />
    <PageContent>
      <DynamicListPage
        :schema="$schemas.openTitle"
        :service="$api.openTitles"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicListPage from '@/components/dynamics/DynamicListPage';

export default {
  name: 'ListOpenTitles',
  components: { PageHeader, PageContent, DynamicListPage },
};
</script>
